export const PREMIUM_STATUS_API_PATH =
  '/_serverless/payments-checkout-server/pay-button/premiumStatus';
